import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class MetricsTooltipService {

  // ========== GENERAL METRIC TOOLTIPS ==========

  getSalesTooltip(): string {
    return 'Sales Performance: Shows how revenue compares to what would be expected based on the external factors - passersby, weather, sales trends. Overdelivering (above target), Balanced (on target), Underperforming (below target).';
  }

  getQPITooltip(): string {
    return 'Queue Performance Indicator: Measures operational efficiency - how efficiently guests are served. Green (excellent), Yellow (good), Orange (needs attention), Red (poor performance).';
  }

  getExperienceTooltip(): string {
    return 'Guest Experience: Measures how fast guests are served based on the average service duration at the selected time of day. Exceptional (fast service), Ok (acceptable), Bad (slow service that impacts satisfaction).';
  }

  getStaffingTooltip(): string {
    return 'Staffing Level: Cost of Labor (CoL) efficiency. Understaffed (too few staff), Adequate (optimal), Overstaffed (too many staff for demand).';
  }

  getColTooltip(): string {
    return 'Cost of Labor (CoL): Percentage of revenue spent on labor costs. Lower percentages indicate better efficiency.';
  }

  // ========== LABEL-SPECIFIC TOOLTIPS ==========

  getSalesLabelTooltip(label: string): string {
    switch (label) {
      case 'Overdelivering':
        return 'Sales are significantly above target - excellent performance';
      case 'Balanced':
        return 'Sales are meeting targets - good performance';
      case 'Underperforming':
        return 'Sales are below target - needs attention';
      default:
        return 'Sales performance indicator';
    }
  }

  getQPILabelTooltip(label: string): string {
    switch (label) {
      case 'Green':
        return 'Excellent efficiency - operations running smoothly';
      case 'Yellow':
        return 'Good efficiency - minor areas for improvement';
      case 'Orange':
        return 'Moderate efficiency - needs attention';
      case 'Red':
        return 'Poor efficiency - immediate action required';
      default:
        return 'Quality Performance Index indicator';
    }
  }

  getExperienceLabelTooltip(label: string): string {
    switch (label) {
      case 'Exceptional':
        return 'Fast service - guests served quickly and efficiently';
      case 'Ok':
        return 'Acceptable service speed - within normal range';
      case 'Bad':
        return 'Slow service - may impact guest satisfaction';
      default:
        return 'Guest experience indicator';
    }
  }

  getStaffingLabelTooltip(label: string): string {
    switch (label) {
      case 'Understaffed':
        return 'Too few staff for current demand - may impact service quality';
      case 'Adequate':
        return 'Optimal staffing level - right balance of cost and service';
      case 'Overstaffed':
        return 'More staff than needed - higher labor costs';
      default:
        return 'Staffing level indicator';
    }
  }
} 